import ContractCard from 'pages/Contracts/components/ContractCard/ContractCard';
import useContract from 'pages/Contracts/hooks/useContract';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

const ContractView = ({ onClose }) => {
  const navigate = useNavigate();
  const { contracts, isLoading, error, fetchContracts } = useContract();

  useEffect(() => {
    fetchContracts();
  }, []);

  const handleViewDetails = (contract) => {
    onClose?.();
    navigate(`/contracts/${contract.public_id}`);
  };

  const handleSubmitProposal = (contract) => {
    onClose?.();
    navigate(`/contracts/${contract.public_id}?action=propose`);
  };

  if (error) {
    return <div className='flex-center'>{error}</div>;
  }

  if (isLoading) {
    return <div className='flex-center'>Loading Contracts...</div>;
  }

  return (
    <div className='custom-scroller'>
      {contracts.map((contract) => (
        <ContractCard
          key={contract.id}
          contract={contract}
          onViewDetails={() => handleViewDetails(contract)}
          onSubmitProposal={() => handleSubmitProposal(contract)}
        />
      ))}
    </div>
  );
};

export default ContractView;
